import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import CardMedia from '@mui/material/CardMedia';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from 'react-i18next';


export default function DisplayImageDialog(props) {

  	const handleClose = () => {
    	props.setDisplayImage(false);
  	};

  	const { t, i18n } = useTranslation("",{lng: props.language});


  	return (
	    	<React.Fragment>
			  {props.item ? (
		      		<Dialog	open={props.display}
					        onClose={handleClose}
					        aria-labelledby="alert-dialog-title"
					        aria-describedby="alert-dialog-description"
					      >
						<DialogTitle id="alert-dialog-title">
			         		{props.item.label}
			        	</DialogTitle>
			        	<DialogContent>
							
							<CardMedia 	component="img"
				        				height="240"
				        				image={"/assets/article-images/" + props.item.src}		        			
				      		/>
			        	</DialogContent>
			        	<DialogActions>
			          		<Button onClick={handleClose} autoFocus>
				         		{t("OK")}
			          		</Button>
			        	</DialogActions>
		      		</Dialog>
				) : (<></>)
				}
			</React.Fragment>
	  );
}